import shaderHelper from "../helpers/shaderHelper";
import * as glslify from 'glslify'
import * as THREE from 'three'

class glPositionOffset {


    constructor() {
        this.sharedUniforms = {};
        this.resultArray = void 0;
        this.init();
    }

    init() {
        this.sharedUniforms.u_glPositionOffset = {
            value: this.resultArray = new THREE.Vector2
        };
        shaderHelper.addChunk("glPositionOffset", glslify(["#define GLSLIFY 1\nuniform vec2 u_glPositionOffset;\n\nvec4 glPositionOffset (vec4 glPosition) {\n\treturn glPosition + vec4(u_glPositionOffset * glPosition.w, 0.0, 0.0);\n}"]));
    };

    setOffset(i, elem) {
        this.resultArray.set(i, elem);
    };

}

const glPositionOffsetInstance = new glPositionOffset();

export default glPositionOffsetInstance;
